import { render, staticRenderFns } from "./AddUnauthorizedDomain.vue?vue&type=template&id=8f57b582&"
import script from "./AddUnauthorizedDomain.vue?vue&type=script&lang=js&"
export * from "./AddUnauthorizedDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports